import { Link } from '@/shared/components/atoms/Link';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';
import ClickableTableRow from '@/shared/components/ClickableTableRow';
import AgeWithTooltip from '@/shared/components/molecules/AgeWithTooltip';
import { type BlockListBlockFragment } from '@/shared/graphql/generated/explorer/graphql';
import BoxIcon from '@/shared/icons/flip-ui-kit/large/Box';
import { tableRowAnimationProps } from '@/shared/utils/consts';
import { formatWithCommas } from '@/shared/utils/numbers';
import { type BlockCounts } from '../../hooks/useBlockCounts';

interface BlockRowProps {
  block: BlockListBlockFragment;
  counts?: BlockCounts;
  preview?: boolean;
}

type LoadedCounts = Exclude<BlockCounts, 'unavailable'>;

const countCell = (counts: BlockCounts | undefined, render: (loaded: LoadedCounts) => string) => {
  if (counts === undefined) return <SkeletonLine />;
  return counts === 'unavailable' ? 'n/a' : render(counts);
};

const BlockRow = ({ block, preview, counts }: BlockRowProps) => (
  <ClickableTableRow {...tableRowAnimationProps} className="h-[64px]" href={`/blocks/${block.id}`}>
    <td>
      <div className="flex space-x-2">
        <BoxIcon width="24" height="24" className=" text-cf-green-1" />
        <Link href={`/blocks/${block.id}`} underline noPropagate>
          {formatWithCommas(block.id)}
        </Link>
      </div>
    </td>
    <td>{countCell(counts, ({ eventsCount }) => formatWithCommas(eventsCount))}</td>
    <td>
      {countCell(counts, ({ extrinsicsCount }) =>
        extrinsicsCount > 0 ? formatWithCommas(extrinsicsCount) : '-',
      )}
    </td>
    {!preview && (
      <td className="w-[1%]">
        {block.validator && (
          <Link underline href={`/validators/${block.validator.account.idSs58}`} noPropagate>
            {block.validator.account.idSs58}
          </Link>
        )}
      </td>
    )}
    <td>
      <div className="flex justify-end whitespace-nowrap text-cf-light-2">
        <AgeWithTooltip timestamp={block.timestamp} />
      </div>
    </td>
  </ClickableTableRow>
);

export default BlockRow;
